import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { watch, ref } from 'vue'
import Stock from './index.vue'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const show = ref(false)
watch(() => store.getters.curShop, async () => {
  show.value = false
  await store.dispatch('whiteUser/getCrossMallShop', {}, { root: true })
  show.value = true
}, {
  immediate: true
})

return (_ctx: any,_cache: any) => {
  return (show.value)
    ? (_openBlock(), _createBlock(Stock, { key: 0 }))
    : _createCommentVNode("", true)
}
}

})